import { ChangeDetectorRef, Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { NgxSuneditorComponent, NgxSuneditorModule } from "../../../../projects/ngx-suneditor/src/public-api";
import { SunEditorOptions } from 'suneditor/src/options';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import plugins from 'suneditor/src/plugins'; // Import all offical available plugins
import { MatListModule } from '@angular/material/list';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DlgSignatureComponent } from '../../commons/dlg-signature/dlg-signature.component';
import { AppTitleService } from '../../services/app-title.service';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentType } from '../../models/DocumentType';
import { AuthService } from '../../services/auth.service';
import { FormControl, FormGroup, Validators, ReactiveFormsModule, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { ParticipantesType } from '../../models/ParticipantesType';
import { ParticipanteService } from '../../services/participante.service';
import { Anexo } from '../../models/Anexo';
import { Documento, NumeracionDocumento, TramitePortal } from '../../models/Document';
import { Participante } from '../../models/ParticipanteType';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import 'moment/locale/es';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { Location } from '@angular/common';
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../commons/dlg-confirm/dlg-confirm.component';
import { ServidorPublico } from '../../models/ServidorPublico';
import { TareaService } from '../../services/tarea.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UtilService } from '../../services/util.service';
import { DlgNumeracionComponent } from '../../components/nuevo/dlg-numeracion/dlg-numeracion.component';
import { DlgDestinoComponent } from '../../components/nuevo/dlg-destino/dlg-destino.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HttpErrorResponse } from '@angular/common/http';
import { DocumentoService } from '../../services/documento.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AnexoService } from '../../services/anexo.service';
import { participantesValidator } from '../../components/nuevo/nuevo.component';
import { EditorType } from '../../emuns/EditorType';
import { WopiService } from '../../services/wopi.service';
import { Wopi } from '../../models/Wopi';
import { WopiAccion } from '../../emuns/WopiAccion';
import { CollaboraEditorComponent } from '../../commons/collabora-editor/collabora-editor.component';

@Component({
  selector: 'app-redactar',
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  imports: [
    NgxSuneditorModule,
    MatCardModule,
    MatListModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    CapitalizePipe,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    CollaboraEditorComponent
  ],
  templateUrl: './redactar.component.html',
  styleUrl: './redactar.component.scss'
})
export class RedactarComponent implements OnInit {
  isEdit = this.route.snapshot.url[0].path === "editar";
  utilService = inject(UtilService)
  public editorHasFocus: boolean = false;
  public fullscreenActive: boolean = false;
  @ViewChild('numeracionInput') numeracionInput: ElementRef<HTMLInputElement> | undefined;
  @ViewChild(NgxSuneditorComponent) ngxSunEditor!: NgxSuneditorComponent;
  @ViewChild('collaboraEditorComponent') collaboraEditor?: CollaboraEditorComponent;
  @ViewChild('anexosFullComponent') anexosFullComponent: any;
  editorOptions: SunEditorOptions = {
    minWidth: "100%",
    height: "50vh",
    plugins: plugins,
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize", "formatBlock"],
      ["bold", "underline", "italic"],
      ["fontColor", "hiliteColor", "removeFormat"],
      ["outdent", "indent"],
      ["align", "list"],
      ["table"]
    ],
    defaultStyle: "font-family: arial; font-size: 12px; text-align: justify;",
    font: ["Arial"],
    fontSize: [8, 10, 12],
    alignItems: ['justify']
  };

  collaboraUrl: string = '';
  collaboraDocumentId: string = '';

  fetchingSubmitForm = false
  snackbarData: ScnackbarData = {}

  readOnlyNumeracion = true;
  documentID: string | null = null
  currentDocument?: TramitePortal
  maxDate = new Date()

  participantes: ParticipantesType = {
    origen: [],
    destino: [],
    copia: [],
    destinoBuzon: []
  };
  usuarioAnterior?: String;

  anexos: Anexo[] = []
  documentTypes: DocumentType[] = []
  numeracionesDocumento: NumeracionDocumento[] = []

  defaultDocumentType = ""
  isPreview = false

  tipoDocumentoSeleccionado: DocumentType | null = null
  numeracionDocumento?: NumeracionDocumento;
  newDocumentForm = new FormGroup({
    documentDate: new FormControl(new Date(), {
      validators: [Validators.required]
    }),
    documentType: new FormControl("", {
      validators: [Validators.required, Validators.pattern(/^[0-9]+$/)]
    }),
    numeracion: new FormControl("", {
      validators: [Validators.required]
    }),
    referenceNumber: new FormControl(""),
    asunto: new FormControl("", {
      validators: [Validators.required, Validators.maxLength(250)]
    }),
    participantes: new FormControl<ParticipantesType>(this.participantes, {
      validators: [
        participantesValidator(),
      ]
    }),
    cuerpo: new FormControl("contenido", {
      validators: []
    }),
  })
  tokenData = this.authService.getTokenData();

  hasParticipated = false;
  isOwner = false;
  estadoTarea: number = -1

  EditorType = EditorType
  editor = signal<EditorType>(EditorType.odt);

  constructor(
    private tareaService: TareaService,
    private documentoService: DocumentoService,
    private documentTypeService: DocumentTypeService,
    private participanteServ: ParticipanteService,
    private anexoService: AnexoService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public dlg: MatDialog,
    private router: Router,
    public location: Location,
    private toast: ToastService,
    private cdr: ChangeDetectorRef,
    private dateService: DateService,
    private activatedRoute: ActivatedRoute,
    private wopiService: WopiService
  ) {
    inject(AppTitleService).setTitle("Redactar adjunto");
  }

  ngOnInit(): void {
    this.documentID = this.activatedRoute.snapshot.paramMap.get("id")

    const userLogin = this.tokenData;
    if (userLogin) {
      if (this.isEdit && this.documentID) {
        this.anexoService.getById(this.documentID).subscribe({
          next: (response: TramitePortal) => {
            this.currentDocument = response
            this.loadCurrentDocumentData()
          }
        });
      } else {
        this.participanteServ.getParticipanteServidorPublico().subscribe({
          next: (res: any[]) => {
            const currentParticipant = res.find((c: any) => c.ciruc === userLogin.sub) as any;
            if (currentParticipant) {
              let { fechaUso, ...res } = currentParticipant as ServidorPublico;
              const participante: Participante = {
                id: res.id.toString(),
                ciruc: res.ciruc,
                departamento: res.departamento,
                idTipoSolicitante: 1,
                nombres: new CapitalizePipe().transform((res.apellidos || '').trim() + " " + (res.nombres || '').trim()),
                cargo: res.cargo,
                titulo: res.titulo,
                institucion: '',
                portavoz: 0
              }
              this.participantes.origen.push(participante);
              this.newDocumentForm.controls.participantes.setValue(this.participantes)

              //this.setCuerpoDocumento()
              this.loadNumeracionDocumento()

              this.wopiService.preparar(WopiAccion.nuevo).subscribe((wopi: Wopi) => {
                this.collaboraDocumentId = wopi.id;
                this.collaboraUrl = wopi.url;
                this.cdr.detectChanges();
              })
            }
          },
        });
      }
    }

    this.loadDocumentTypes(null);
  }

  loadCurrentDocumentData() {
    this.participantes.origen = this.currentDocument!.de as Participante[]
    this.participantes.destino = this.currentDocument!.para
    this.participantes.copia = this.currentDocument!.cc ? this.currentDocument!.cc : []
    this.participantes.destinoBuzon = this.currentDocument!.buzonesPara ? this.currentDocument!.buzonesPara : []

    this.newDocumentForm.controls.participantes.setValue(this.participantes)

    const date = this.dateService.parseDateString(this.currentDocument!.fecha as string)
    this.newDocumentForm.controls.documentDate.setValue(date)
    //this.loadDocumentTypes(this.currentDocument!.tipoDocumento.descripcion)
    this.newDocumentForm.controls.documentDate.setValue(new Date(this.currentDocument!.fecha))
    this.newDocumentForm.controls.numeracion.setValue(this.currentDocument!.numeroDocumento)
    this.newDocumentForm.controls.referenceNumber.setValue(this.currentDocument!.numeroReferencia)
    this.newDocumentForm.controls.asunto.setValue(this.currentDocument!.asunto)
    this.newDocumentForm.controls.cuerpo.setValue(this.currentDocument!.cuerpo)

    if (this.currentDocument!.editor === EditorType.odt) {
      this.wopiService.preparar(WopiAccion.redactar, this.documentID ? Number(this.documentID) : undefined ).subscribe((wopi: Wopi) => {
        this.collaboraDocumentId = wopi.id;
        this.collaboraUrl = wopi.url;
        this.cdr.detectChanges();
      })
    } else {
      this.editor.set(EditorType.html)
      this.currentDocument!.editor = EditorType.html
      this.cdr.detectChanges();
      this.ngxSunEditor.setContents(this.currentDocument!.cuerpo);
    }

  }

  loadDocumentTypes(documentTypeDescription: string | null) {
    if (!documentTypeDescription) {
      documentTypeDescription = "Oficio"
    }
    this.documentTypeService.list().subscribe({
      next: (response: DocumentType[]) => {
        this.documentTypes = response;
        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);
        if (defaultType) {
          this.tipoDocumentoSeleccionado = defaultType
          this.defaultDocumentType = defaultType.id.toString();

          this.newDocumentForm.controls.documentType.setValue(this.defaultDocumentType);
        }
        this.cdr.detectChanges();
      }
    });
  }

  manageChangedDocumentType(event: MatSelectChange) {
    const selectedDocumentType = this.documentTypes.find((type) => type.id == event.value)
    this.tipoDocumentoSeleccionado = selectedDocumentType!
    if (this.isEdit) return
    if (this.numeracionDocumento) {
      this.setNumeracion(this.numeracionDocumento?.numeracion)
    } else {
      if (this.newDocumentForm.controls.numeracion.value) {
        var valor = this.newDocumentForm.controls.numeracion.value;
        var num = this.newDocumentForm.controls.numeracion.value.substring(0, valor.length - 3)
        num = num + "-" + this.tipoDocumentoSeleccionado!.descripcion.substring(0, 2).toUpperCase()
        this.newDocumentForm.controls.numeracion.setValue(num);
      }
    }
  }

  manageEditorContentChange(event: { content: string; core: unknown }) {
    this.newDocumentForm.controls.cuerpo.setValue(event.content)
    this.cdr.detectChanges()
  }

  loadNumeracionDocumento() {
    this.documentoService.getNumeracion(this.tokenData?.id).subscribe({
      next: (response: any) => {
        this.numeracionesDocumento = response
      }
    })
  }

  setCuerpoDocumento() {
    const cuerpo = `<p>De mi consideración: </p>
    <br>`

    this.newDocumentForm.controls.cuerpo.setValue(cuerpo)
    this.ngxSunEditor.setContents(cuerpo)
  }

  onEditConfirm() {
    const data: DlgConfirmComponentData = {
      title: "Editar numeraci\u00f3n?",
      message: "¿Est\xe1 seguro de continuar?",
      confirmLabel: "Si, continuar",
      closeLabel: "No"
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: data
    })
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.readOnlyNumeracion = false;
        this.newDocumentForm.controls.numeracion.setValue("");
        this.numeracionInput?.nativeElement.focus();
      }
    });
  }

  onDlgNumeracion() {
    const dialogRef = this.dlg.open(DlgNumeracionComponent, {
      data: this.participantes.origen.at(0)!.id
    });
    dialogRef.afterClosed().subscribe((result: any | undefined) => {
      if (result && result.id) {
        this.numeracionesDocumento = result
        this.setNumeracion(result.numeracion);
        this.readOnlyNumeracion = true;
        this.numeracionInput!.nativeElement.blur();
        this.cdr.detectChanges();
      } else if (result === 1) {
        this.onEditConfirm();
      }
    });
  }

  setNumeracion(numeracion: string = "") {
    this.newDocumentForm.controls.numeracion.setValue(numeracion);
    var numeracion = numeracion.replace("{ANIO}", new Date().getFullYear().toString());
    numeracion = numeracion.replace("{NUMERO}", "####");
    numeracion = numeracion.replace("{TIPO}", this.tipoDocumentoSeleccionado!.descripcion.substring(0, 2).toUpperCase());
    this.newDocumentForm.controls.numeracion.setValue(numeracion);
  }

  async submitNewDocumentForm() {
    this.fetchingSubmitForm = true

    if (this.editor() === EditorType.odt && this.collaboraEditor) {
      await this.collaboraEditor?.saveAndWait();
    }

    let editor = this.editor();

    const formControls = this.newDocumentForm.controls
    const newDocument: TramitePortal = {
      id: (this.isEdit) ? this.currentDocument?.id : Number.parseInt(this.documentID ? this.documentID : "0"),
      tipoDocumento: parseInt(formControls.documentType.value!),
      tipoSolicitante: 1,
      idMemo: this.currentDocument?.idMemo,
      idAnexo: this.currentDocument?.idAnexo,
      categoria: 0,
      tipificacion: 0,
      fecha: this.dateService.formatDateToCustomString(formControls.documentDate.value!),
      numeroDocumento: formControls.numeracion.value!,
      numeroReferencia: formControls.referenceNumber.value!,
      asunto: formControls.asunto.value!,
      cuerpo: formControls.cuerpo.value!,
      anexos: [],
      anexosMencionados: this.getAnexosMencionados(),
      de: formControls.participantes.value!.origen,
      para: formControls.participantes.value!.destino,
      buzonesPara: formControls.participantes.value!.destinoBuzon,
      cc: formControls.participantes.value!.copia,
      editor: editor,
      collaboraId: this.collaboraDocumentId
    }

    console.log(newDocument);

    this.tareaService.saveRedaccion(newDocument).subscribe(({
      next: (response: any) => {
        this.currentDocument = response
        this.snackbarData.message = "Documento almacenado"
        this.snackbarData.style = SnackbarStyles.Success
        this.fetchingSubmitForm = false
        this.toast.show(this.snackbarData)
        if (this.isPreview) {
          this.openDlgSign()
          this.router.navigateByUrl("editar/redactar/" + this.currentDocument?.idAnexo, { replaceUrl: true })
        } else {
          this.onBack();
        }
        this.isPreview = false
      },
      error: () => {
        this.snackbarData.title = "Error"
        this.snackbarData.message = "No se pudo guardar el documento"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.autoClose = false;
        this.fetchingSubmitForm = false
        this.toast.show(this.snackbarData)
      }
    }))
  }

  openDlgDestino() {
    const dlgDestino = this.dlg.open(DlgDestinoComponent, {
      width: '80vw',
      maxWidth: '80vw',
      data: this.participantes
    });

    dlgDestino.afterClosed().subscribe(result => {
      if (result) {
        this.participantes = result;
        this.newDocumentForm.controls.participantes.setValue(this.participantes)
        if (!this.documentID) {
          this.loadNumeracionDocumento()
        }
      }
    });
  }

  openDlgSign() {
    const dlgSign = this.dlg.open(DlgSignatureComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {
        firmar: 0,
        idAnx: this.currentDocument?.idAnexo
      },
    });
  }

  getAnexosMencionados(): number[] {
    if (this.anexosFullComponent) {
      return this.anexosFullComponent.getAnexosMencionadosIds();
    }
    return [];
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date!)
  }

  onBack() {
    this.location.back();
  }

  onCollaboraReady() {
    console.log('Editor Collabora listo');
  }

  onFullscreen(): void {
    this.fullscreenActive = true;
    this.collaboraEditor?.enterFullscreen();
  }

  onEditorFocus(focused: boolean): void {
    if (focused) this.editorHasFocus = true;
  }

  onCollaboraContentChanged() {
    // El documento se guarda automáticamente en Collabora
  }
  onCollaboraError(error: string) {
    this.toast.show({
      style: SnackbarStyles.Error,
      message: error
    });
  }

}
